import React from 'react';
import styles from '../styles';
import { FaMapMarkerAlt } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoIosMail } from "react-icons/io";
import LanguagesDrop from './LanguagesDrop';
import { useTranslation } from 'react-i18next';

const ContactHeader = ({dis}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  // Map language codes to country codes for flags
  const languageToCountry = {
    fr: 'FR', // France
    en: 'US', // United States
    ar: 'MA'  // Morocco
  };

  // Get current flag based on selected language
  const getCurrentFlag = () => {
    const countryCode = languageToCountry[i18n.language] || 'FR';
    return `https://flagsapi.com/${countryCode}/flat/64.png`;
  };

  return (
      <div className={`${isRTL ? '!font-cairo' : 'font-jakarta'} ${dis ? 'hidden' : 'block'} ${isRTL ? 'rtl' : 'ltr'} w-full bg-gradient-to-br from-primary via-primary to-transparent p-[1.13px] rounded-[12px]`}>
        <div className='w-full flex justify-between items-center py-3 rounded-[12px] bg-white'>
          <div className='w-[90%] flex justify-around'>
            <div className={`flex gap-1 items-center ${isRTL && 'flex-row-reverse'}`}>
              <FaMapMarkerAlt size={20} fill='#FF4949' />
              <a href="https://maps.app.goo.gl/Sq9GpBJyb2CuUSm7A" target='_blank' rel='noreferrer'>        
                <h3 className='text-primary text-[16px]'>{t('contact.address')}</h3>
              </a>
            </div>
            <span className='text-primary flex justify-center items-center text-[20px]'>|</span>
            <div className={`flex gap-1 items-center ${isRTL && 'flex-row-reverse'}`}>
              <a href={`tel:+212661267760`}><BiSolidPhoneCall size={20} fill='#FF4949' /></a>
              <a href="tel:+212661267760">              
                <h3 className='text-primary text-[16px]'>{t('contact.phone')}</h3>
              </a>
            </div>
            <span className='text-primary flex justify-center items-center text-[20px]'>|</span>
            <div className={`flex gap-1 items-center ${isRTL && 'flex-row-reverse'}`}>
              <a href={`mailto:${t('contact.email')}`}><IoIosMail size={20} fill='#FF4949' /></a>
              <a href={`mailto:${t('contact.email')}`} target='_blank' rel='noreferrer'>
                <h3 className='text-primary text-[16px]'>{t('contact.email')}</h3>
              </a>
            </div>
          </div>
          <div className={`languages ${isRTL ? 'pl-3' : 'pr-3'} flex items-center gap-2`}>
            <img 
              src={getCurrentFlag()} 
              alt="Selected Language Flag" 
              className="w-8 h-8 object-cover"
            />
            <LanguagesDrop w-={20} className='bg-[#EAE9E9] text-[#0F0F0F] hover:bg-white' classN='text-paragraph data-[focus]:bg-white data-[focus]:text-gray-900' classN1='bg-[#EAE9E9]'/>
          </div>
        </div>
      </div>
  )
}

export default ContactHeader